import { Building2 } from "lucide-react";
import { logoUrl } from "@/frontend/utils/shared";
import { ehrProviderMap } from "@/frontend/constants/ehr-providers";

export function ProviderLogo({ provider }: { provider: string }) {
  const p = ehrProviderMap.get(provider);
  const src = p ? logoUrl(p.logo) : null;
  if (!src) return <Building2 className="w-8 h-8 text-muted-foreground" />;
  return (
    <img
      src={src}
      alt={p?.label ?? provider}
      className="w-8 h-8 object-contain"
      onError={(e) => { e.currentTarget.style.display = "none"; }}
    />
  );
}
